import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Typography } from '@mui/material';
import * as SX from './sx';
import type { PlanCellValueProps as Props } from './types';

export function PlanCellValue({ value }: Props) {
  if (value === 'check') {
    return <CheckCircleIcon sx={SX.checkIcon} />;
  }
  if (value === 'dash') {
    return (
      <Typography variant="body2" color="text.disabled">
        —
      </Typography>
    );
  }
  if (value === 'comingSoon') {
    return (
      <Box component="span" sx={SX.comingSoonPill}>
        <Typography variant="body4" fontWeight={500} color="grey.700" noWrap>
          Coming Soon
        </Typography>
      </Box>
    );
  }
  return (
    <Typography variant="body2" fontWeight={500} color="text.secondary">
      {value}
    </Typography>
  );
}
